// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
import UsageTrackerContainer from './UsageTrackingContainer';
import { checkUrlForUUID } from './uuidUtils';
export const checkCookiesHaveBeenAcceptedBeforeSignup = () => {
  const hasCookiesOrEmail = UsageTrackerContainer.areCookiesAccepted || UsageTrackerContainer.isEmailProvided;
  return hasCookiesOrEmail && !checkUrlForUUID();
};
export const hasDeclinedCookies = () => Cookies.get('__hs_opt_out') === 'yes';